import { differenceInYears, isEqual, isAfter, isBefore, isValid, parse, parseISO } from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';

window.Parsley
    .addValidator('customEmailValidator', {
        requirementType: 'string',
        validateString(value) {
            return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
        },
        messages: {
            en: 'Please enter valid email address',
        },
    })
    .addValidator('datepicker', {
        requirementType: 'string',
        validateString(value) {
            return isValid(parse(value, 'MM/dd/yyyy', new Date()));
        },
        messages: {
            en: 'Date must be in MM/DD/YYYY format',
        },
    })
    .addValidator('imageDimsMin', {
        requirementType: 'string',
        validateString(value, requirement, parsley) {
            const file = parsley.$element[0].files[0];
            const [minWidth, minHeight] = requirement.split('x');
            const img = new Image();
            const deferred = $.Deferred();

            img.onload = () => {
                if (img.width < minWidth || img.height < minHeight) {
                    deferred.reject();
                } else {
                    deferred.resolve();
                }
            };

            img.src = window.URL.createObjectURL(file);

            return deferred.promise();
        },
        messages: {
            en: 'Image dimensions have to be at least %spx.',
        },
    })
    .addValidator('phoneUs', {
        requirementType: 'string',
        validateString(value) {
            return /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(value);
        },
        messages: {
            en: 'Please enter valid phone number: (xxx) xxx-xxxx',
        },
    })
    .addValidator('zip', {
        requirementType: 'number',
        validateString(value) {
            let isValid = false;

            if (value.length == 5) {
                $.ajax({
                    url: `/api/zipcode/${value}`,
                    async: false,
                    timeout: 5,
                    success: function(data) {
                        isValid = parseInt(data.zip) === parseInt(value) && data.primary_city !== '';
                    },
                });
            }

            return isValid;
        },
        messages: {
            en: 'Please enter a valid ZIP Code.',
        },
    })
    .addValidator('user', {
        requirementType: 'string',
        validateString(value) {
            let isValid = false;

            if (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
                $.ajax({
                    url: `/api/user/check/${value}`,
                    async: false,
                    timeout: 5,
                    success: function(data) {
                        if (!data.exists) {
                            window.Parsley.addMessage('en', 'user', 'A user with this email address already exists on the site.');
                        }
                        isValid = !data.exists;
                    },
                });
            } else {
                window.Parsley.addMessage('en', 'user', 'This value should be a valid email.');
            }

            return isValid;
        },
        messages: {
            en: 'A user with this email address already exists on the site.',
        },
    })
    .addValidator('dob', {
        requirementType: 'string',
        validateString(value) {
            const now = new Date();
            const dob = parse(value, 'MM/dd/yyyy', new Date());

            if (!isValid(dob)) {
                window.Parsley.addMessage('en', 'dob', 'Please enter a valid DOB.');
                return false;
            }

            const diffInYears = differenceInYears(now, dob);

            if (diffInYears < 0) {
                window.Parsley.addMessage('en', 'dob', 'Cannot be a future date.');
                return false;
            }

            if (diffInYears < 17) {
                window.Parsley.addMessage('en', 'dob', 'Must be greater than 17 years ago.');
                return false;
            }

            if (diffInYears > 120) {
                window.Parsley.addMessage('en', 'dob', 'Must be less than 120 years ago.');
                return false;
            }

            return true;
        },
        messages: {
            en: 'Please enter a valid DOB.',
        },
    })
    .addValidator('twitter', {
        requirementType: 'string',
        validateString(value) {
            return /^@?(\w){1,15}$/.test(value);
        },
        messages: {
            en: 'Please enter a valid Twitter handle.',
        },
    })
    .addValidator('facebook', {
        requirementType: 'string',
        validateString(value) {
            return /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w-]*)?/.test(value);
        },
        messages: {
            en: 'Please enter a valid Facebook profile.',
        },
    })
    .addValidator('linkedin', {
        requirementType: 'string',
        validateString(value) {
            return /^https?:\/\/((www|\w\w)\.)?linkedin.com\/((in\/[^/]+\/?)|(pub\/[^/]+\/((\w|\d)+\/?){3}))$/.test(value);
        },
        messages: {
            en: 'Please enter a valid LinkedIn profile.',
        },
    })
    .addValidator('youtube', {
        requirementType: 'string',
        validateString(value) {
            return /^(https?:\/\/)?((www\.)?youtube\.com|youtu\.?be)\/.+$/.test(value);
        },
        messages: {
            en: 'Please enter a valid YouTube video URL.',
        },
    })
    .addValidator('requiredIf', {
        requirementType: 'string',
        validateString: function(value, requirement) {
            if ($(requirement).val()) {
                return !!value;
            }

            return true;
        },
        messages: {
            en: 'This field is required.',
        },
    })
    .addValidator('requiredIfAny', {
        requirementType: 'string',
        validateString: function(value, requirement) {
            for (const selector of requirement.selectors) {
                const $input = $(selector);

                if ($input.is(':checkbox')) {
                    if ($input.is(':checked')) {
                        return !!value;
                    }
                } else if ($input.val()) {
                    return !!value;
                }
            }

            return true;
        },
        messages: {
            en: 'This field is required.',
        },
    })
    .addValidator('requiredIfChecked', {
        requirementType: 'string',
        validateString: function(value, requirement) {
            if (!value) {
                return !$(requirement).prop('checked');
            }

            return true;
        },
        messages: {
            en: 'This value is required.',
        },
    })
    /**
     * Makes the field conditionally required, based on whether or not some
     * other given field's value is equal to the given value.
     */
    .addValidator('requiredIfValue', {
        requirementType: 'string',
        validateString: function(value, requirement) {
            const $field = $(requirement.selector);

            if ($field.val() != requirement.value) {
                return true;
            }

            return !!value;
        },
        messages: {
            en: 'This value is required.',
        },
    })
    .addValidator('requiredWhenFieldValue', {
        requirementType: 'string',
        validateString: function(value, requirement) {
            // requirement should be like `.selector|value`
            const requirementsArray = String.prototype.split.call(requirement, '|');
            if (requirementsArray.length < 2) {
                throw `Requirement ${requirement} does not contain a field and at least one value.`;
            }
            const selector = requirementsArray.shift();
            // If the other field's value is the required value, then this field is required
            if (
                !!$(selector).length &&
                requirementsArray.includes(String.prototype.toString.call($(selector).val().toString()))
            ) {
                return !!value;
            }
            // otherwise this field is not required
            return true;
        },
    })
    .addValidator('fileextension', {
        validateString: function(value, rule, parsleyInstance) {
            const input = parsleyInstance.$element[0];
            const file = input.files[0];
            const inputAccepts = input.accept.split(',').map((val) => val.trim());
            if (!inputAccepts.includes(file.type)) {
                const freindlyFileExts = inputAccepts.map((ext) => {
                    const fileExtArr = ext.split('/');
                    return fileExtArr.length > 0 ? fileExtArr[1] : fileExtArr[0];
                }).join(', ');
                return $.Deferred().reject(`Incorrect file type (supported formats are ${freindlyFileExts}`);
            }
        },
    })
    .addValidator('noMaliciousDomains', {
        validateString: function(value) {
            const isBadDomain = /@.*\.(ru|cc|top|cn|tv|sx|lc|st|pm|ng|su)$/.test(value);
            return !isBadDomain;
        },
        messages: {
            en: 'This value should be a valid email.',
        },
    })
    .addValidator('noLinks', {
        validateString: function(value) {
            const urlPattern = /\b(?:https?:\/\/|www\.)\S+|<a\s+[^>]*?href\s*=\s*['"][^'"]+['"]/;
            const isUrl = urlPattern.test(value);
            return !isUrl;
        },
        messages: {
            en: 'Web links not allowed.',
        },
    })
    .addValidator('mindate', {
        requirementType: 'string',
        validateString(value, requirement) {
            if (value) {
                let parsed;

                try {
                    parsed = parseISO(requirement.substring(0, 10));
                } catch {
                    return $.Deferred().reject('Must be a properly formatted date.');
                }

                const current = parse(value, 'MM/dd/yyyy', new Date());

                if (!isEqual(current, parsed) && !isAfter(current, parsed)) {
                    return $.Deferred().reject(
                        'Must be a date on or after ' +
                        format(utcToZonedTime(parsed, 'UTC'), 'MM/dd/yyyy HH:mm:ss zzz'),
                    );
                }
            }

            return true;
        },
        messages: {
            en: 'Must be a date on or after %s.',
        },
    })
    .addValidator('maxdate', {
        requirementType: 'string',
        validateString(value, requirement) {
            return isBefore(
                parse(value, 'MM/dd/yyyy', new Date()),
                parseISO(requirement),
            );
        },
        messages: {
            en: 'Must be a date on or before %s.',
        },
    })
    .addValidator('ljoEmploymentType', {
        requirementType: 'string',
        validateMultiple: (values, req) => {
            let passes = false;
            for (let i in req) {
                if (!passes) {
                    passes = values.includes(req[i]);
                }
            }
            return passes;
        },
        messages: {
            en: 'Locum Tenens or Permanent is required.',
        },
    })
    .addValidator('greaterThanZero', {
        requirementType: 'number',
        validateNumber: function(value) {
            return value > 0;
        },
        messages: {
            en: 'Value must be greater than zero',
        },
    })
    .addValidator('afterStartDate', {
        validateString: function(value, requirement) {
            let startDate;
            if (requirement) {
                startDate = $(`#${requirement}`).val();
            } else {
                startDate = $('#start_date').val();
            }

            if (!startDate) {
                return true;
            }

            const startDateParsed = parse(startDate, 'MM/dd/yyyy', new Date());
            const endDateParsed = parse(value, 'MM/dd/yyyy', new Date());

            return isBefore(startDateParsed, endDateParsed);
        },
        messages: {
            en: 'End Date cannot be before Start Date',
        },
    })
    .addValidator('invalidSelection', {
        requirementType: 'string',
        priority: 513, // This is necessary to ensure that this is the first error message to show when used.
        validateString: function(value, requirment, field) {
            const options = $(field.element).find('option').get();

            const passed = options
                .filter(function(option) {
                    /** @var {HTMLOptionElement} option */
                    return option.hasAttribute('selected');
                })
                .every((o) => !o.hasAttribute('invalid'));

            return passed;
        },
        validateMultiple: function(value, requirement, field) {
            const options = $(field.element).find('option').get();

            const passed = options
                .filter(function(option) {
                    /** @var {HTMLOptionElement} option */
                    return option.hasAttribute('selected');
                })
                .every((o) => !o.hasAttribute('invalid'));

            return passed;
        },
        messages: {
            en: 'Value is no longer valid. Choose a valid value.',
        },
    });

window.Parsley.addAsyncValidator('zip', function(xhr) {
    return xhr.status !== 404;
}, '/api/zipcode/{value}');

window.Parsley.addValidator('minSwitchesEnabled', {
    requirementType: 'string',
    validateMultiple: (values, req) => {
        const min = req.min;
        let enabled = 0;

        for (const selector of req.selectors) {
            const $input = $(selector);

            if ($input.prop('checked')) {
                enabled++;
            }
        }

        return enabled >= min;
    },
    messages: {
        en: 'Please enable the minimum number of toggles',
    },
});
